import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { RenderCheckboxRadioField, RenderSubmitButton } from '../common/form';

const DidntBuyForm = ({ handleSubmit, pristine, submitting, valid, reason, onChangeAction }) => ( // eslint-disable-line
  <form onSubmit={handleSubmit} className="didnt-buy-form">
    <div className="margin-left-2x">
      <Field
        id="changed-mind"
        name="reason"
        component={RenderCheckboxRadioField}
        type="radio"
        label="I was just looking."
        styleOverride
        value="CHANGED_MIND"
      />
      <Field
        id="out-of-stock"
        name="reason"
        component={RenderCheckboxRadioField}
        type="radio"
        label="The gift was not in stock."
        styleOverride
        value="OUT_OF_STOCK"
      />
      <Field
        id="wrong-price"
        name="reason"
        component={RenderCheckboxRadioField}
        type="radio"
        label="The price was different from what I saw on Zola."
        styleOverride
        value="WRONG_PRICE"
      />
    </div>

    <div className="wrapping-button-container product-actions">
      <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid || true} className="btn btn-primary btn-wide" value="finish" />
    </div>
  </form>
);


DidntBuyForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  reason: PropTypes.string,
  onChangeAction: PropTypes.func,
};

export default reduxForm({
  form: 'DidntBuyForm',
  initialValues: {
    reason: 'CHANGED_MIND'
  }
})(DidntBuyForm);



// WEBPACK FOOTER //
// ./src/components/registryitem/DidntBuyForm.jsx